export const LANG = "en";

export function ml(value, lang = LANG) {
	if (!value) return "";
	if (typeof value === "string") return value;
	return value[lang] || value.en || Object.values(value).find(Boolean) || "";
}

export function asMl(value, lang = LANG) {
	if (!value || typeof value === "object") return value || {};
	return { [lang]: value };
}

export function formatDate(value) {
	if (!value) return "";
	return new Date(value).toLocaleString();
}
